<template lang="pug">
div(:class="{'in-uploader':inUploader}").wrap-item-pose-changer.relative.w-full
  div.wrap-window.relative.w-full
    div.toggle-adjust-pose.absolute.f.fc.w-full
      div.f.fm
        div(@click="showAdjustPose = !showAdjustPose"
          ).btn-toggle.btn.f.fm.px8.py6.cursor-pointer
          v-icon(size="24" dark).mr4 {{showAdjustPose ? 'mdi-chevron-left' : 'mdi-human'}}
          span.fz14 {{showAdjustPose ? 'ポーズテンプレート' : 'ポーズを調整'}}

    div(v-if="!showAdjustPose").wrap-tags.pt10.pl10
      div(v-for="tag in candidateTags"
        @click="onTag(tag)"
        :class="{'active': selectedTemplateTags.includes(tag)}"
        ).tag.px12.pt5.pb4.rounded.mr8.cursor-pointer
        span.fz12 {{tag}}

    div(v-if="!showAdjustPose" ref="wrapPoseTmps").wrap-pose-tmps.pb50.h-full
      div(v-if="poseTemplates[0]").f.flex-between.flex-wrap
        div(v-for="poseTemplate in poseTemplates"
          @click="onPoseTemplate(poseTemplate)").pose-tamplate.cursor-pointer
          div.f.fh
            img(:src="poseTemplate.mainImg").object-fit-cover
      div(v-else).now-loading-pose-tmps.relative.f.fh.w-full.h-full
        v-progress-circular(v-if="!isInitialized"
          :color="pallete.$active_color" indeterminate)
        span(v-else).fz14.block.text-center.pt8 ポーズがありません

    div(v-if="showAdjustPose").wrap-adjust-pose.relative
      div.wrap-tab-header.px12.pt12
        div.tab-header.f.flex-between.mb12
          div(v-for="tab in tabs"
            @click="currentTab = tab"
            :class="{'active': currentTab == tab}").tab.f.fh.py6.cursor-pointer
            span.fz12 {{tab}}
      
      div(@click="isMirrorinig = !isMirrorinig"
        ).wrap-btn-mirroring.absolute.f.fh.r12.t42.z1.w32.h32.circle.cursor-pointer
        v-icon(:color="isMirrorinig ? pallete.$active_color : 'white'"
          size="22" dark) mdi-highway

      div.wrap-changer.pb50
        div(v-if="currentTab == 'ポーズ'").wrap-bone-changer.relative.changer.px12.pb4
          //- div(@click="isMirrorinig = !isMirrorinig"
            ).wrap-btn-mirroring.absolute.f.fh.r12.t2.w32.h32.circle.cursor-pointer
            v-icon(:color="isMirrorinig ? pallete.$active_color : 'white'"
              size="22" dark) mdi-highway
          div.f.fc.mb12
            AtomBoneJointPicker(@setCurrentJoint="setCurrentJoint"
              :currentJoint="currentJoint" :isMirrorinig="isMirrorinig")
          div(v-for="bone in bonesProps"
            v-if="currentJoint && currentJoint.name == bone.name")
            v-slider(v-model="bone.rotation.x" label="x"
              min="-3.0" max="3.0" step="0.00001"
              color="red" dark)
            v-slider(v-model="bone.rotation.y" label="y"
              min="-3.0" max="3.0" step="0.00001"
              color="green" dark)
            v-slider(v-model="bone.rotation.z" label="z"
              min="-3.0" max="3.0" step="0.00001"
              color="blue" dark)
            //- span {{ `x: ${bone.rotation.x} y: ${bone.rotation.y} z: ${bone.rotation.x}` }}

        div(v-if="currentTab == '左手'").wrap-hand-changer.changer.px12.pb4
          div.f.fc.mb12
            AtomLeftHandJointPicker(@setCurrentJoint="setCurrentJoint")
          div(v-for="bone in bonesProps"
            v-if="currentJoint && currentJoint.name == bone.name")
            v-slider(v-model="bone.rotation.x" label="x"
              min="-2.0" max="2.0" step="0.001"
              color="red" dark)
            v-slider(v-model="bone.rotation.y" label="y"
              min="-2.0" max="2.0" step="0.001"
              color="green" dark)
            v-slider(v-model="bone.rotation.z" label="z"
              min="-2.0" max="2.0" step="0.001"
              color="blue" dark)
          div.grasp-changer.f.fm.flex-between
            span.fz14 開
            v-slider(v-model="leftHandGraspValue"
              min="0.0" max="1.0" step="0.001" dark).pt7
            span.fz14 握

        div(v-if="currentTab == '右手'").wrap-hand-changer.changer.px12.pb4
          div.f.fc.mb12
            AtomRightHandJointPicker(@setCurrentJoint="setCurrentJoint")
          div(v-for="bone in bonesProps"
            v-if="currentJoint && currentJoint.name == bone.name")
            v-slider(v-model="bone.rotation.x" label="x"
              min="-2.0" max="2.0" step="0.001"
              color="red" dark)
            v-slider(v-model="bone.rotation.y" label="y"
              min="-2.0" max="2.0" step="0.001"
              color="green" dark)
            v-slider(v-model="bone.rotation.z" label="z"
              min="-2.0" max="2.0" step="0.001"
              color="blue" dark)
          div.grasp-changer.f.fm.flex-between
            span.fz14 開
            v-slider(v-model="rightHandGraspValue"
              min="0.0" max="1.0" step="0.001" dark).pt7
            span.fz14 握
</template>

<style lang="scss" scoped>
@import "@/scss/_variables.scss";
$header_tab_area_height: 104px;
$tags_head_height: 42px;
.wrap-item-pose-changer {
  max-height: calc(#{$device_height} - (#{$studio_basic_margin} * 2) - #{$header_tab_area_height});

  &.in-uploader {
    height: 100%;
    .wrap-window {
      height: 100%;
      .wrap-pose-tmps {
        height: calc(100% - #{$tags_head_height});
      }
    }
  }
  .wrap-window {
    max-width: $studio_window_max_width; // min-height: 520px;
    .toggle-adjust-pose {
      bottom: 12px;
      z-index: 1;
      .btn {
        border-radius: 9px;
        color: $dark_primary_text_color;
        background: $active_color;
        box-shadow: $box_shadow;
      }
    }
    .wrap-tags {
      overflow-x: auto;
      white-space: nowrap;
      -webkit-overflow-scrolling: touch;
      .tag {
        /* 横スクロール用 */
        display: inline-block;
        font-size: 14px;
        border: solid $dark_primary_text_color 1px;
        span {
          color: $dark_primary_text_color;
        }
        &.active {
          background: $active_color;
          border: solid $active_color 1px;
        }
      }
    }
    .wrap-pose-tmps {
      // max-height: 80vh; // MEMO: 大きくしすぎるとassetUploaderで枠からはみ出る
      // max-height: calc(55vh - #{$header_tab_area_height});
      max-height: calc(#{$device_height} - (#{$studio_basic_margin} * 2) - #{$header_tab_area_height} - #{$tags_head_height});
      // min-height: 480px;
      overflow: scroll;
      .pose-tamplate {
        width: 50%;
      }
      .now-loading-pose-tmps {
        min-height: 160px;
        span {
          color: $dark_primary_text_color;
        }
      }
      -ms-overflow-style: none;
      scrollbar-width: none;
      &::-webkit-scrollbar {
        display:none;
      }
    }
    .wrap-adjust-pose {
      min-height: 480px;
      .wrap-tab-header {
        width: 100%;
        .tab-header {
          background: $secondary_active_color;
          border-radius: 18px;
          color: $dark_primary_text_color;
          overflow: hidden;
          .tab {
            width: 100%;
            &.active {
              background: $active_color;
            }
          }
        }
      }
      .wrap-btn-mirroring {
        background: $dark_primary_bg_color;
        &.active {
          background: $active_color;  
        }
      }
      .label {
        color: $dark_primary_text_color;
      }
      .wrap-changer {
        .changer {
          width: 100%;
          max-height: calc(60vh - #{$header_tab_area_height});
          // max-height: calc(55vh - #{$header_tab_area_height});
          overflow: scroll;
          scrollbar-width: none;
          -ms-overflow-style: none;
          scrollbar-width: none;
        }
        .changer::-webkit-scrollbar {
          display:none;
        }
        .grasp-changer {
          color: $dark_primary_text_color;
        }
      }
    }
  } // .wrap-window
}
</style>

<style lang="scss">
@import "@/scss/_variables.scss";

.wrap-item-pose-changer {
  .v-messages {
    display: none;
  }
}
</style>

<script>
import { createNamespacedHelpers } from 'vuex'
const { mapState: mapStateAuth, mapActions: mapActionsAuth } = createNamespacedHelpers('auth')
import database from '@/database'
import { bones, blendShapes, leftHandBones, rightHandBones } from '@/plugins/vrm-nums'
import vrmManager from '@/components/mixin/vrmManager'
import AtomBoneJointPicker from '@/components/atom/studio/AtomBoneJointPicker'
import AtomLeftHandJointPicker from '@/components/atom/studio/AtomLeftHandJointPicker'
import AtomRightHandJointPicker from '@/components/atom/studio/AtomRightHandJointPicker'

export default {
  mixins: [vrmManager],
  components: {
    AtomBoneJointPicker, AtomLeftHandJointPicker, AtomRightHandJointPicker
  },
  props: {
    targetObject: {
      type: Object,
      required: false
    },
    vrm: {
      type: Object,
      required: false
    },
    objects: {
      type: Array,
      required: false
    },
    transformControls: {
      type: Object,
      default: null
    },
    inUploader: {
      type: Boolean,
      default: false
    },
    defaultAsset: {
      type: Object,
      required: false
    }
  },
  data () {
    return {
      showAdjustPose: false,

      poseTemplates: [],
      loadMorePoseTemplates: true, limit: 12,
      oldestDateOfPoseTemplateSeconds: new Date().getTime() / 1000,

      // allPoseTemplates: [],
      allTemplateTags: [],
      selectedTemplateTags: [],
      isLoadingMorePoseTemplate: false,

      currentTab: 'ポーズ',
      tabs: ['ポーズ', '左手', '右手'],
      bonesProps: [],
      leftHandGraspValue: 0,
      rightHandGraspValue: 0,
      currentBlendShape: null,
      currentJoint: null,
      currentBoneNode: null,
      preventBonesUpdateByWatch: true,
      isMirrorinig: false,

      isInitialized: false
    }
  },
  computed: {
    ...mapStateAuth(['uid']),
    bones () {
      return bones
    },
    leftHandBones () {
      return leftHandBones
    },
    rightHandBones () {
      return rightHandBones
    },
    // leftHandBonesForGrasp () {
    //   return leftHandBones.filter(bone => {
    //     return ['']
    //   })
    // },
    // rightHandBonesForGrasp () {
    //   return rightHandBones.filter(bone => {
    //     return ['']
    //   })
    // },
    boneNames () {
      return bones.map(bone => bone.name)
    },
    // showingPoseTemplates () {
    //   let resultTemplates
    //   if (!this.selectedTemplateTags[0]) {
    //     resultTemplates = this.allPoseTemplates
    //   } else {
    //     resultTemplates = this.allPoseTemplates.filter(a => {
    //       let including = false
    //       for (let i=0; i<this.selectedTemplateTags.length; i++) {
    //         if (a.tags.includes(this.selectedTemplateTags[i])) {
    //           including = true
    //         }
    //       }
    //       return including
    //     })
    //   }
    //   return resultTemplates
    // },
    candidateTags () {
      const resultTags = this.allTemplateTags.filter(t => {
        return !this.defaultPoseTags.includes(t)
      })
      return this.defaultPoseTags.concat(resultTags)
    }
  },
  watch: {
    bonesProps: {
      handler () {
        if (this.preventBonesUpdateByWatch) {
          this.preventBonesUpdateByWatch = false
          return
        }
        if (this.isMirrorinig) {
          const targetProp = this.bonesProps
            .filter(b => b.name === this.currentJoint.name)[0]
          let mirrorProp = this.bonesProps
            .filter(b => b.name === this.currentJoint.mirrorJoint)[0]
          if (mirrorProp) {
            mirrorProp.rotation.x = targetProp.rotation.x
            mirrorProp.rotation.y = -targetProp.rotation.y
            mirrorProp.rotation.z = -targetProp.rotation.z
            // console.log(this.currentJoint.mirrorJoint)
            // console.log(this.currentJoint.mirrorJoint, mirrorProp.rotation)
          }
        }
        const rightUppderArm = this.bonesProps
          .filter(e => e.name === 'RightUpperArm')[0]
        const rr = rightUppderArm.rotation
        console.log('rightUppderArm:', `x: ${rr.x} y: ${rr.y} z: ${rr.z}`)

        this.$emit('updateBoneProp', this.bonesProps)
      },
      deep: true
    },
    targetObject (currentObject, previousObject) {
      if (previousObject && previousObject.uuid !== currentObject.uuid) {
        this.initialize()
      }
    },
    leftHandGraspValue () {
      const leftHandBonesNames = this.leftHandBones.map(b => b.name)
      this.bonesProps = this.bonesProps.map(bone => {
        if (leftHandBonesNames.includes(bone.name)) {
          const axisForGrasp = this.leftHandBones
            .filter(b => b.name === bone.name)[0].axisForGrasp
          bone.rotation.x = axisForGrasp.x * this.leftHandGraspValue
          bone.rotation.y = axisForGrasp.y * this.leftHandGraspValue
          bone.rotation.z = axisForGrasp.z * this.leftHandGraspValue
        }
        if (this.isMirrorinig) {
          const rightHandBonesNames = this.rightHandBones.map(b => b.name)
          if (rightHandBonesNames.includes(bone.name)) {
            const axisForGrasp = this.rightHandBones
              .filter(b => b.name === bone.name)[0].axisForGrasp
            bone.rotation.x = axisForGrasp.x * this.leftHandGraspValue
            bone.rotation.y = axisForGrasp.y * this.leftHandGraspValue
            bone.rotation.z = axisForGrasp.z * this.leftHandGraspValue
          }
        }
        return bone
      })
    },
    rightHandGraspValue () {
      const rightHandBonesNames = this.rightHandBones.map(b => b.name)
      this.bonesProps = this.bonesProps.map(bone => {
        if (rightHandBonesNames.includes(bone.name)) {
          const axisForGrasp = this.rightHandBones
            .filter(b => b.name === bone.name)[0].axisForGrasp
          bone.rotation.x = axisForGrasp.x * this.rightHandGraspValue
          bone.rotation.y = axisForGrasp.y * this.rightHandGraspValue
          bone.rotation.z = axisForGrasp.z * this.rightHandGraspValue
        }
        if (this.isMirrorinig) {
          const leftHandBonesNames = this.leftHandBones.map(b => b.name)
          if (leftHandBonesNames.includes(bone.name)) {
            const axisForGrasp = this.leftHandBones
              .filter(b => b.name === bone.name)[0].axisForGrasp
            bone.rotation.x = axisForGrasp.x * this.leftHandGraspValue
            bone.rotation.y = axisForGrasp.y * this.leftHandGraspValue
            bone.rotation.z = axisForGrasp.z * this.leftHandGraspValue
          }
        }
        return bone
      })
    },
    showAdjustPose () {
      if (this.showAdjustPose) {
        this.setCurrentJoint({ label: '頭', name: 'Head' })
      } else {
        if (this.transformControls) this.transformControls.detach()
      }
    }
  },
  created () {
    this.initialize()
  },
  mounted () {
    if (this.$refs.wrapPoseTmps) {
      this.$refs.wrapPoseTmps.addEventListener('scroll', this.onScroll)
    }
  },
  beforeUnmount () {
    if (this.$refs.wrapPoseTmps) {
      this.$refs.wrapPoseTmps.removeEventListener('scroll', this.onScroll)
    }
  },
  methods: {
    async initialize () {
      const allBones = this.bones.concat(this.leftHandBones).concat(this.rightHandBones)

      // スタジオインターフェースで特定のキャラクターが選択された場合
      if (this.targetObject && this.targetObject.userData.vrm) {
        this.preventBonesUpdateByWatch = true
        const docId = this.targetObject.userData.docId
        const objectDoc = this.objects.filter(o => o.id === docId)[0]
        this.bonesProps = objectDoc.pose
      } else {
        if (this.defaultAsset) {
          this.bonesProps = this.defaultAsset.photoPose
          // console.log('initialize by default asset')
        } else {
          this.bonesProps = allBones.map(bone => {
            return {
              ...bone,
              rotation: { x: 0.0, y: 0.0, z: 0.0 }
            }
          }).map(bone => {
            if (bone.name === 'LeftUpperArm') bone.rotation.z = 1.2
            if (bone.name === 'RightUpperArm') bone.rotation.z = -1.2
            if (bone.name === 'LeftLowerArm') bone.rotation.z = 0.2          
            if (bone.name === 'RightLowerArm') bone.rotation.z = -0.2          
            return bone
          })
        }
      }

      // this.allPoseTemplates = await database
      //   .poseTemplateCollection().getAllPoses()
      // this.showingPoseTemplates = this.allPoseTemplates

      // const allTags = this.allPoseTemplates.map(a => {
      //   return a.tags
      // }).flat()
      // for (let i=0; i<allTags.length; i++) {
      //   if (!this.allTemplateTags.includes(allTags[i])) {
      //     this.allTemplateTags.push(allTags[i])
      //   }
      // }

      const tags = await database.tagCollection()
        .getTagsByType({ type: 'pose' })
      this.allTemplateTags = tags.map(t => t.value)

      this.loadPoseTemplates()

      this.isInitialized = true
    },
    onScroll () {
      const wrapPoseTmps = this.$refs.wrapPoseTmps
      if (wrapPoseTmps.scrollHeight - wrapPoseTmps.clientHeight <=  wrapPoseTmps.scrollTop + 8) {
        if (this.loadMorePoseTemplates) this.loadPoseTemplates()
      }
    },
    async loadPoseTemplates () {
      if (this.isLoadingMorePoseTemplate) return
      
      this.isLoadingMorePoseTemplate = true
      const newPoseTemplates = await database
        .poseTemplateCollection()
        .getPosesByTags({
          tags: this.selectedTemplateTags,
          limit: this.limit,
          seconds: this.oldestDateOfPoseTemplateSeconds
        })
      if (newPoseTemplates[0]) {
        this.poseTemplates = this.poseTemplates.concat(newPoseTemplates)
        this.oldestDateOfPoseTemplateSeconds = newPoseTemplates[newPoseTemplates.length - 1].createdAt._seconds
      } else {
        this.loadMorePoseTemplates = false
      }

      await this.sleep(800)
      this.isLoadingMorePoseTemplate = false
    },
    setCurrentJoint (joint) {
      this.currentJoint = joint
      this.attachJointToTransformControls()
    },
    attachJointToTransformControls () {
      if (this.transformControls && this.currentJoint) {
        this.currentBoneNode = this.getNormalizedBoneNodeByName({ 
          vrm: this.vrm, name: this.currentJoint.name
        })
        this.transformControls.setMode('rotate')
        this.transformControls.attach(this.currentBoneNode)
      }
    },
    updateBonePropByTransformControls () {
      if (this.currentBoneNode) {
        this.currentBoneNode.rotation
        let targetProp = this.bonesProps
          .filter(b => b.name === this.currentJoint.name)[0]
        if (this.isVRM1({ vrm: this.vrm })) {
          targetProp.rotation = {
            x: -this.currentBoneNode.rotation.x,
            y: -this.currentBoneNode.rotation.y,
            z: -this.currentBoneNode.rotation.z
          }
        } else {
          targetProp.rotation = {
            x: this.currentBoneNode.rotation.x,
            y: this.currentBoneNode.rotation.y,
            z: this.currentBoneNode.rotation.z
          }
        }
      }
    },
    toBlendShapeWindow () {
      this.showAdjustPose = true
      this.currentTab = '表情'
    },
    onPoseTemplate (poseTemplate) {
      if (this.$route.name === 'edit-frame' || this.inUploader) {
        let poseTemplateAdaptation = {
          createdAt: new Date(),
          createdBy: this.uid,
          poseTemplateId: poseTemplate.id
        }
        if (this.$route.params.comicId) poseTemplateAdaptation.comicId = this.$route.params.comicId
        // console.log('poseTemplateAdaptation:', poseTemplateAdaptation)
        database.poseTemplateAdaptationCollection(poseTemplate.id).add(poseTemplateAdaptation)
      }
      // 配列をコピー
      let copiedPose = JSON.parse(JSON.stringify(poseTemplate.pose))      
      this.bonesProps = copiedPose
    },
    onTag (tag) {
      if (this.selectedTemplateTags.includes(tag)) {
        this.selectedTemplateTags = this.selectedTemplateTags
          .filter(s => s !== tag)
      } else {
        this.selectedTemplateTags.push(tag)
      }

      this.poseTemplates = []
      this.loadMorePoseTemplates = true
      this.isLoadingMorePoseTemplate = false
      this.oldestDateOfPoseTemplateSeconds = new Date().getTime() / 1000
      this.loadPoseTemplates()
    }
  }
}
</script>
